import { pick, prop, propOr } from 'ramda';
import { api, setter, fetchParams, fetchResponse } from '@/modules/helper';

export default {
  namespaced: true,

  state: {
    pagination: {
      skip: 0,
      limit: 10,
    },
    items: [],
  },

  mutations: {
    dynamicSet: setter,
  },

  getters: {
    items: prop('items'),
    pagination: prop('pagination'),
  },

  actions: {
    create(state, payload) {
      return api.post('rewardTemplate', payload.data);
    },

    update(state, payload) {
      return api.patch(`rewardTemplate/${payload.id}`, payload.data);
    },

    fetch({ commit, state }, payload) {
      return api
        .get('rewardTemplate', {
          params: fetchParams(state, payload),
        })
        .then(data => commit('dynamicSet', fetchResponse(data)));
    },

    fetchActive({ commit }, userId) {
      return api
        .get(`rewardTemplate/active/${userId}`)
        .then(data => commit('dynamicSet', { items: data.data }));
    },

    find(state, id) {
      return api
        .get(`rewardTemplate/${id}`)
        .then(({ data }) =>
          pick(
            ['id', 'name', 'description', 'points', 'shops', 'start', 'end'],
            data,
          ),
        )
        .catch(error => error);
    },

    remove({ dispatch }, id) {
      return api.delete(`rewardTemplate/${id}`).then(() => dispatch('fetch'));
    },

    reactivate({ dispatch }, id) {
      return api
        .patch(`rewardTemplate/reactivate/${id}`)
        .then(() => dispatch('fetch'));
    },
  },
};
